import CardFormScreen from './CardFormScreen';

import { switchToPaymentMethodsStep } from '@/store/new-order/stepsSlice';
import { useAppDispatch, useAppSelector } from '@/store/new-order';
import { type Plan } from '@/utils/mapProductObject';
import { onCardFormSubmit } from '@/utils/stripe/newOrderSubmitAdapter';

const CardFormScreenAdapter = () => {
  const { isSubmitting, selectedPlan, couponDiscountPercentage } = useAppSelector((state) => ({
    isSubmitting: state.isSubmitting,
    selectedPlan: state.plans.selectedPlan as Plan,
    couponDiscountPercentage: state.coupon.discountPercentage,
  }));
  const dispatch = useAppDispatch();
  const onBackButtonClick = () => dispatch(switchToPaymentMethodsStep());

  return (
    <CardFormScreen
      selectedPlanBlockData={{ selectedPlan, couponDiscountPercentage }}
      isSubmitting={isSubmitting}
      onBackButtonClick={onBackButtonClick}
      onCardFormSubmit={onCardFormSubmit}
    />
  );
};

export default CardFormScreenAdapter;
